import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import ProgressBar from '../../../../components/progress-bar';
import styles from './styles.css';
import CustomHeader from '../../../../components/god-table/header';
import {
  fetchWinLossOpportunityFeedback,
} from '../../DashboardActions';
import { getWinLossOpportunityFeedbacks } from '../../DashboardReducer';
import ScoreRenderer from './cells/ScoreRenderer';
import PricePositionRenderer from './cells/PricePositionRenderer';
import CapturedOnRenderer from './cells/CapturedOnRenderer';
import PerformanceRenderer from './cells/PerformanceRenderer';
import ReasonCellRenderer from './cells/ReasonCellRenderer';
import ContactDetailRenderer from './cells/ContactDetailRenderer';
import CompetitorRenderer from './cells/CompetitorRenderer';

const MAIN_HEIGHT_COMPACT = 70;


class FeedbackManagerRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.onColumnResized = this.onColumnResized.bind(this);
    this.resetRowHeights = this.resetRowHeights.bind(this);
    this.showLoadingOverlay = this.showLoadingOverlay.bind(this);
    this.hideLoadingOverlay = this.hideLoadingOverlay.bind(this);
  }

  componentWillMount() {
    const { data, feedbacks } = this.props;
    if (!feedbacks) {
      this.showLoadingOverlay();
      this.setState({ loading: true });
      if (this.props.node) {
        this.props.node.setRowHeight(MAIN_HEIGHT_COMPACT);
      }
      this.props.dispatch(fetchWinLossOpportunityFeedback(data.opportunity_id))
        .then(() => {
          this.setState({ loading: false }, () => {
            this.hideLoadingOverlay();
            this.refreshTable();
          });
        });
    } else {
      this.setState({ loading: false }, () => {
        this.refreshTable();
      });
    }
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    if (this.props.api) {
      const detailGridId = this.createDetailGridId();
      // ag-Grid is automatically destroyed
      this.props.api.removeDetailGridInfo(detailGridId);
    }
    this.mounted = false;
  }

  refreshTable() {
    if (this.props.api) {
      this.props.api.refreshCells();
    }
  }
  showLoadingOverlay() {
    if (this.props.api) {
      this.props.api.showLoadingOverlay();
    }
  }
  hideLoadingOverlay() {
    if (this.props.api) {
      this.props.api.hideOverlay();
    }
  }

  
  onGridReady(params) {
    const detailGridId = this.createDetailGridId();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.props.api) {
      const gridInfo = {
        id: detailGridId,
        api: this.gridApi,
        columnApi: this.gridColumnApi,
      };
      this.props.api.addDetailGridInfo(detailGridId, gridInfo);
    }
    this.resetRowHeights();
  }

  getIsWon() {
    const { data } = this.props;
    const { stage } = data;
    return stage === 'Won';
  }

  handleRequestShowInsight(insightId) {
    const { data } = this.props;
    this.props.requestShowInsight(data.opportunity_id, insightId);
  }

  onColumnResized() {
    this.resetRowHeights();
  }

  resetRowHeights() {
    if (this.gridApi) {
      this.gridApi.resetRowHeights();
      if (this.el) {
        if (this.props.node) {
          this.props.node.setRowHeight(this.el.clientHeight);
        }
        if (this.props.api) {
          this.props.api.resetRowHeights();
        }
      }
    }
  }

  createDetailGridId() {
    return `detail_${this.props.data.opportunity_id}`;
  }

  renderGrid() {
    const { feedbacks } = this.props;
    const isWon = this.getIsWon();
    const ourHeader = isWon ? 'Your Win Reasons' : 'Your Loss Reasons';
    const competitorHeader = isWon ? 'Competitor Loss Reasons' : 'Competitor Win Reasons';

    const columnDefs = [
      {
        field: 'advantage_score',
        headerName: 'Score',
        sortable: true,
        suppressMenu: true,
        width: 80,
        sort: 'desc',
        cellRenderer: ScoreRenderer,
        type: 'numericColumn',
        cellRendererParams: {
          column: {
            description: 'Your competitive advantage versus the strongest competitor',
          },
        },
      },
      {
        headerName: 'Contact',
        field: 'contact_name',
        suppressMenu: true,
        width: 120,
        cellRenderer: ContactDetailRenderer,
        cellRendererParams: {
          idField: 'sfa__contact_id',
        },
      },
      {
        field: 'outcome_reasons',
        headerName: ourHeader,
        suppressMenu: true,
        suppressSorting: true,
        cellRenderer: ReasonCellRenderer,
        width: 200,
        cellClass: 'cell-wrap-text',
        autoHeight: true,
        cellRendererParams: {
          isClient: true,
          requestShowInsight: this.handleRequestShowInsight,
        },
      },
      {
        field: 'outcome_reasons',
        headerName: 'Competitor',
        suppressMenu: true,
        suppressSorting: true,
        cellRenderer: CompetitorRenderer,
        width: 100,
        cellClass: 'cell-wrap-text',
        autoHeight: true,
        cellRendererParams: {
          field: 'outcome_reasons',
        },
      },
      {
        field: 'outcome_reasons',
        headerName: competitorHeader,
        suppressMenu: true,
        suppressSorting: true,
        cellRenderer: ReasonCellRenderer,
        width: 200,
        cellClass: 'cell-wrap-text',
        autoHeight: true,
        cellRendererParams: {
          isClient: false,
          requestShowInsight: this.handleRequestShowInsight,
          column: {
            description: 'Outcome reasons for the strongest competitor',
          },
        },
      },
      {
        field: 'price_position_label',
        headerName: 'Price Position',
        suppressMenu: true,
        width: 130,
        cellRenderer: PricePositionRenderer,
        cellRendererParams: {
          column: {
            description: 'Your price position versus the strongest competitor',
          },
        },
      },
      {
        field: 'driver_performances',
        headerName: 'Performance',
        suppressMenu: true,
        suppressSorting: true,
        cellRenderer: PerformanceRenderer,
        width: 170,
        cellClass: 'cell-wrap-text',
        autoHeight: true,
        cellRendererParams: {
          column: {
            description: 'Your performance in the three key decision driver',
          },
        },
      },
      {
        field: 'interviews',
        headerName: 'Captured on',
        suppressMenu: true,
        width: 118,
        cellRenderer: CapturedOnRenderer,
        cellRendererParams: {
          column: {
            description: 'Date buyer provided feedback on their experience',
          },
        },
      },
    ];
    const showNav = false;
    return (
      <div>
        <div className={`${styles.contactTable} ag-theme-alpine`} style={{ width: '100%' }} >
          <AgGridReact
            reactNext
            id={this.createDetailGridId()}
            enableColResize
            enableSorting
            columnDefs={columnDefs}
            rowData={feedbacks}
            onGridReady={this.onGridReady}
            onColumnResized={this.onColumnResized}
            domLayout="autoHeight"
            components={{
              agColumnHeader: CustomHeader,
            }}
          />
        </div>
      </div>
    );
  }

  renderEmpty() {
    const cls = this.props.api ? styles.contactWrapper : null;
    return (
      <div ref={(el) => { this.el = el; }} className={cls}>
        No contacts have provided feedback yet.
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    const cls = this.props.api ? styles.contactWrapper : null;
    if (loading) {
      return (<div className={cls}><ProgressBar /></div>);
    }
    const { feedbacks } = this.props;
    if (!feedbacks || feedbacks.length === 0) {
      return this.renderEmpty();
    }
    return (
      <div ref={(el) => { this.el = el; }} className={cls}>
        {this.renderGrid()}
      </div>
    );
  }
}

FeedbackManagerRenderer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({
    opportunity_id: PropTypes.string,
  }).isRequired,
  api: PropTypes.shape({
    addDetailGridInfo: PropTypes.func.isRequired,
    removeDetailGridInfo: PropTypes.func.isRequired,
    onRowHeightChanged: PropTypes.func.isRequired,
  }),
  node: PropTypes.shape({
    setRowHeight: PropTypes.func.isRequired,
  }),
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})),
  requestShowInsight: PropTypes.func,
};
FeedbackManagerRenderer.defaultProps = {
  api: null,
  node: null,
  feedbacks: null,
  requestShowInsight: () => {},
};
function mapStateToProps(state, ownProps) {
  return {
    feedbacks: getWinLossOpportunityFeedbacks(state, ownProps.data.opportunity_id),
  };
}

export default connect(mapStateToProps)(FeedbackManagerRenderer);
